var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("text-label-row", {
        attrs: {
          title: "AidApplication.BasicInfo.Investment.Type",
          value: _vm.$t(_vm.selectedBOptionEnumString)
        }
      }),
      _vm._v(" "),
      !_vm.isSupportApartments
        ? _c("text-area-row", {
            attrs: {
              title: "AidApplication.BasicInfo.Investment.OperationName",
              id: "operationname",
              required: true,
              maxLength: 200,
              rows: 2
            },
            model: {
              value: _vm.aidapplication.basicInfo.operationName,
              callback: function($$v) {
                _vm.$set(_vm.aidapplication.basicInfo, "operationName", $$v)
              },
              expression: "aidapplication.basicInfo.operationName"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("text-area-row", {
        attrs: {
          title: "AidApplication.BasicInfo.Investment.Purpose",
          id: "purpose",
          required: true,
          maxLength: 1000,
          rows: 10
        },
        model: {
          value: _vm.aidapplication.basicInfo.purpose,
          callback: function($$v) {
            _vm.$set(_vm.aidapplication.basicInfo, "purpose", $$v)
          },
          expression: "aidapplication.basicInfo.purpose"
        }
      }),
      _vm._v(" "),
      _c("date-input-row", {
        attrs: {
          title: _vm.startTimeTitle,
          name: _vm.startTimeTitle,
          placeholder: _vm.$t("DatePicker.FormatPlaceholder"),
          required: true,
          rules: _vm.startTimeRules
        },
        model: {
          value: _vm.aidapplication.basicInfo.startTime,
          callback: function($$v) {
            _vm.$set(_vm.aidapplication.basicInfo, "startTime", $$v)
          },
          expression: "aidapplication.basicInfo.startTime"
        }
      }),
      _vm._v(" "),
      _c("date-input-row", {
        attrs: {
          title: _vm.endTimeTitle,
          name: _vm.endTimeTitle,
          placeholder: _vm.$t("DatePicker.FormatPlaceholder"),
          required: true,
          rules: _vm.endTimeRules
        },
        model: {
          value: _vm.aidapplication.basicInfo.endTime,
          callback: function($$v) {
            _vm.$set(_vm.aidapplication.basicInfo, "endTime", $$v)
          },
          expression: "aidapplication.basicInfo.endTime"
        }
      }),
      _vm._v(" "),
      _vm.isICT
        ? _c("location-control", {
            attrs: {
              location: _vm.aidapplication.basicInfo.location,
              showChannels: !_vm.isAy
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isPremisesRenovationOrImprovement
        ? _c(
            "div",
            [
              _c("target-info-control", {
                attrs: {
                  item: _vm.aidapplication.basicInfo.investment.targetInfo
                }
              }),
              _vm._v(" "),
              _c("address-control", {
                attrs: { item: _vm.aidapplication.basicInfo.investment.address }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }